<template>
  <div class="column is-12" v-if="refbookFiles.length > 0">
    <h3 class="has-text-primary is-size-2">{{ $t('Документы') }}:</h3>
    <hr>
    <div class="accred-comps-documents">
      <ws-accred-comps-documents-item
        v-for="type of TYPES"
        :key="type.id"
        :label="type.label"
        :document="type.id"
        :item="getItemById(type.id)"
        :accred-comp-guid="accredCompGuid"
        @change="updateItem"
        :perm="refbookFiles"
      />
    </div>
  </div>

</template>

<script>
import { mapState } from 'vuex'
import { get } from 'lodash'

export default {
  name: 'WsAccredCompsDocuments',
  props: {
    accredCompGuid: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapState('authentication', ['user']),
    refbookFiles () {
      return get(this.user, 'permission.scope.services.refbook.files', [])
    }
  },
  data () {
    return {
      TYPES: {
        // REQUEST: {
        //   id: 'request',
        //   label: this.$t('Заявка на аккредитацию')
        // },
        // EGRUL: {
        //   id: 'egrul',
        //   label: this.$t('Загрузите ЕГРЮЛ')
        // },
        PZ: {
          id: 'pz',
          label: this.$t('План застройки')
        },
        IL: {
          id: 'il',
          label: this.$t('Перечень оборудования/инструментов')
        },
        CONSUMABLE_MATERIALS: {
          id: 'consumable_materials',
          label: this.$t('Расходные материалы')
        },
        LETTERS_GUARANTEES: {
          id: 'letters_guarantees',
          label: this.$t('Письма, гарантии (*.zip, *.rar)')
        },
        OTHER_DOCUMENT: {
          id: 'other_document',
          label: this.$t('Другой документ')
        }
      },
      newItems: []
    }
  },
  watch: {
    items: {
      handler (items) {
        if (items) {
          this.newItems = items
        }
      },
      immediate: true
    },
    newItems: {
      handler (items) {
        // console.log(items)
        // this.$emit('change', items)
      },
      deep: true
    }
  },
  methods: {
    getItemById (id) {
      return this.items && this.items.find(item => {
        return item.document === id
      })
    },
    updateItem (item) {
      const existItem = this.newItems.find(_item => _item.document === item.document)
      if (existItem && item.file) {
        Object.assign(existItem, item)
      }
      if (!existItem && item.file) {
        this.newItems.push(Object.assign(item, { operation: 'update' }))
      }
      if (existItem && item.file) {
        Object.assign(existItem, { operation: 'update' })
      }
      if (existItem && !item.file) {
        Object.assign(existItem, { operation: 'delete' })
      }
      this.$emit('change', this.newItems)
    }
  }
}
</script>
